(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-post"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGBlogPost extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-blog-post')) {
      customElements.define('yg-blog-post', YGBlogPost);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collection-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGCollectionSwiper extends YGUtils {
      constructor() {
        super();
        
        this.init();
      }

      init() {
        const columnsMobile = parseFloat(this.dataset.columnsMobile) || 2;
        const columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;

        new Swiper(this.querySelector('.swiper'), {
          spaceBetween: 24, //轮播中幻灯片之间的间距
          slidesPerView: columnsMobile,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            //设置响应式断点
            700: {
              slidesPerView: columnsDesktop, //当窗口宽度大于等于700px时，设置每屏显示的幻灯片数量为4
              spaceBetween: 48,
            },
          },
        });
      }
    }

    if (!window.customElements.get('yg-collection-swiper')) {
      window.customElements.define('yg-collection-swiper', YGCollectionSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-card-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGProductCardSwiper extends YGUtils {
      constructor() {
        super();
        
        this.init();
      }

      init() {
        const columnsMobile = parseFloat(this.dataset.columnsMobile) || 2;
        const columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;

        new Swiper(this.querySelector('.swiper'), {
          spaceBetween: 14, //轮播中幻灯片之间的间距
          slidesPerView: columnsMobile,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            type: "progressbar",
          },
          breakpoints: {
            //设置响应式断点
            700: {
              slidesPerView: columnsDesktop, //当窗口宽度大于等于700px时，设置每屏显示的幻灯片数量为4
              spaceBetween: 16,
            },
          },
        });
      }
    }

    if (!window.customElements.get('yg-product-card-swiper')) {
      window.customElements.define('yg-product-card-swiper', YGProductCardSwiper);
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scroll-image"] && !Shopify.designMode) return;
  try {
    
    class YGScrollImage extends HTMLElement {
    constructor() {
        super();
        this._init();
    }

    _init() {
        const sectionId = this.getAttribute("data-section-id");
        if (!sectionId) return;

        // 等待图片加载完成后再计算
        this._waitForImages().then(() => {
        this._calculateAnimation();
        });

        // 监听窗口大小变化
        if (window.ResizeObserver) {
        new ResizeObserver(() => {
            this._calculateAnimation();
        }).observe(this);
        }

        // 鼠标悬停暂停/恢复
        const container = document.getElementById(`yg-scrolling-container-${sectionId}`);
        if (container) {
        container.addEventListener('mouseenter', () => this._pauseScrolling());
        container.addEventListener('mouseleave', () => this._resumeScrolling());
        }
    }

    _waitForImages() {
        return new Promise((resolve) => {
        const images = this.querySelectorAll('yg-image img, yg-image svg');
        if (images.length === 0) {
            resolve();
            return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= totalImages) {
            // 额外等待一小段时间确保布局稳定
            setTimeout(resolve, 100);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
            checkComplete();
            } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
            }
        });
        });
    }

    _calculateAnimation() {
        const scrollingSpeed = parseFloat(this.getAttribute("scrolling-speed") || 45);
        const sectionId = this.getAttribute("data-section-id");
        
        // 获取第一个滚动元素的宽度
        const firstElement = this;
        const elementWidth = firstElement.offsetWidth;
        
        if (elementWidth === 0) {
        // 如果宽度为0，延迟重试
        setTimeout(() => this._calculateAnimation(), 100);
        return;
        }

        // 获取两个元素之间的 gap（从父元素获取）
        const listElement = document.getElementById(`yg-scrolling-list-${sectionId}`);
        const computedStyle = window.getComputedStyle(listElement);
        const gap = parseFloat(computedStyle.gap) || 0;
        
        // 动画移动的距离 = 元素宽度 + gap（这样第二个元素才能无缝接上）
        const moveDistance = elementWidth + gap;

        // 计算动画时长：速度越大，移动越快（时长越短）
        // scrollingSpeed 表示每秒移动的像素数
        const duration = moveDistance / scrollingSpeed;

        // 设置CSS变量
        this.style.setProperty('--marquee-width', `${moveDistance}px`);
        this.style.setProperty('--marquee-duration', `${duration}s`);

        // 确保所有元素使用相同的动画参数
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((el) => {
        if (el !== this) {
            el.style.setProperty('--marquee-width', `${moveDistance}px`);
            el.style.setProperty('--marquee-duration', `${duration}s`);
        }
        });
    }

    _pauseScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'paused';
        });
    }

    _resumeScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'running';
        });
    }
    }

    if (!window.customElements.get("yg-scroll-image")) {
    window.customElements.define("yg-scroll-image", YGScrollImage);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-scrolling-item"] && !Shopify.designMode) return;
  try {
    
    class YGScrollImage extends HTMLElement {
    constructor() {
        super();
        this._init();
    }

    _init() {
        const sectionId = this.getAttribute("data-section-id");
        if (!sectionId) return;

        // 等待图片加载完成后再计算
        this._waitForImages().then(() => {
        this._calculateAnimation();
        });

        // 监听窗口大小变化
        if (window.ResizeObserver) {
        new ResizeObserver(() => {
            this._calculateAnimation();
        }).observe(this);
        }

        // 鼠标悬停暂停/恢复
        const container = document.getElementById(`yg-scrolling-container-${sectionId}`);
        if (container) {
        container.addEventListener('mouseenter', () => this._pauseScrolling());
        container.addEventListener('mouseleave', () => this._resumeScrolling());
        }
    }

    _waitForImages() {
        return new Promise((resolve) => {
        const images = this.querySelectorAll('yg-image img, yg-image svg');
        if (images.length === 0) {
            resolve();
            return;
        }

        let loadedCount = 0;
        const totalImages = images.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= totalImages) {
            // 额外等待一小段时间确保布局稳定
            setTimeout(resolve, 100);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
            checkComplete();
            } else {
            img.addEventListener('load', checkComplete, { once: true });
            img.addEventListener('error', checkComplete, { once: true });
            }
        });
        });
    }

    _calculateAnimation() {
        const scrollingSpeed = parseFloat(this.getAttribute("scrolling-speed") || 45);
        const sectionId = this.getAttribute("data-section-id");
        
        // 获取第一个滚动元素的宽度
        const firstElement = this;
        const elementWidth = firstElement.offsetWidth;
        
        if (elementWidth === 0) {
        // 如果宽度为0，延迟重试
        setTimeout(() => this._calculateAnimation(), 100);
        return;
        }

        // 获取两个元素之间的 gap（从父元素获取）
        const listElement = document.getElementById(`yg-scrolling-list-${sectionId}`);
        const computedStyle = window.getComputedStyle(listElement);
        const gap = parseFloat(computedStyle.gap) || 0;
        
        // 动画移动的距离 = 元素宽度 + gap（这样第二个元素才能无缝接上）
        const moveDistance = elementWidth + gap;

        // 计算动画时长：速度越大，移动越快（时长越短）
        // scrollingSpeed 表示每秒移动的像素数
        const duration = moveDistance / scrollingSpeed;

        // 设置CSS变量
        this.style.setProperty('--marquee-width', `${moveDistance}px`);
        this.style.setProperty('--marquee-duration', `${duration}s`);

        // 确保所有元素使用相同的动画参数
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((el) => {
        if (el !== this) {
            el.style.setProperty('--marquee-width', `${moveDistance}px`);
            el.style.setProperty('--marquee-duration', `${duration}s`);
        }
        });
    }

    _pauseScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'paused';
        });
    }

    _resumeScrolling() {
        const sectionId = this.getAttribute("data-section-id");
        const allElements = document.querySelectorAll(`yg-scroll-image[data-section-id="${sectionId}"]`);
        allElements.forEach((item) => {
        item.style.animationPlayState = 'running';
        });
    }
    }

    if (!window.customElements.get("yg-scroll-image")) {
    window.customElements.define("yg-scroll-image", YGScrollImage);
    }

  } catch(e) { console.error(e); }
})();
})();
